/**
 * editor2/shared/FieldDisplay.tsx
 * クリックで編集ダイアログを開くフィールド表示コンポーネント
 * ReservationEditorPanel の DetailItem + onClick パターンを抽出
 */
import React from 'react';

interface FieldDisplayProps {
  label: string;
  value: any;
  onClick?: () => void;
  noBorder?: boolean;
  color?: string;
  suffix?: string;
  displayValue?: string;
}

export default function FieldDisplay({
  label,
  value,
  onClick,
  noBorder = false,
  color,
  suffix,
  displayValue,
}: FieldDisplayProps) {
  const shown = displayValue ?? (value != null && value !== '' ? String(value) : '-');
  const isClickable = !!onClick;

  return (
    <div className="gc-field">
      <label
        className="gc-label"
        style={{ fontSize: '0.85rem', color: '#64748b' }}
      >
        {label}
      </label>
      <div
        className="gc-input"
        onClick={onClick}
        role={isClickable ? 'button' : undefined}
        tabIndex={isClickable ? 0 : undefined}
        onKeyDown={
          isClickable
            ? (e: React.KeyboardEvent) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  onClick?.();
                }
              }
            : undefined
        }
        style={{
          background: isClickable ? '#fff' : '#f8fafc',
          border: noBorder ? 'none' : '1px solid #e2e8f0',
          borderRadius: '4px',
          padding: '8px 12px',
          minHeight: '38px',
          display: 'flex',
          alignItems: 'center',
          color: color || '#334155',
          cursor: isClickable ? 'pointer' : 'default',
          transition: 'background 0.15s',
        }}
      >
        <span style={{ flex: 1 }}>{shown}</span>
        {suffix && (
          <span style={{ marginLeft: 4, color: '#94a3b8', fontSize: '0.85rem' }}>
            {suffix}
          </span>
        )}
      </div>
    </div>
  );
}
